import React from 'react';

export default function LuminousChokerSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="luminousBand" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#00E5FF" />
          <stop offset="50%" stopColor="#E040FB" />
          <stop offset="100%" stopColor="#00E5FF" />
        </linearGradient>
        <radialGradient id="luminousGlow" cx="0.5" cy="0.5" r="0.6">
          <stop offset="0%" stopColor="#E040FB" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#E040FB" stopOpacity="0" />
        </radialGradient>
      </defs>
      {/* Outer soft glow halo */}
      <ellipse cx="20" cy="20.5" rx="20" ry="6" fill="url(#luminousGlow)" />
      {/* Choker band */}
      <rect x="2" y="18" width="36" height="5" rx="2.5" fill="url(#luminousBand)" />
      {/* Inner glow line */}
      <rect x="2" y="19.5" width="36" height="2" rx="1" fill="white" opacity="0.4" />
      {/* Central gem */}
      <circle cx="20" cy="20.5" r="3.5" fill="#E040FB" />
      <circle cx="20" cy="20.5" r="3.5" fill="white" opacity="0.25" />
      <circle cx="19" cy="19.5" r="1" fill="white" opacity="0.85" />
      {/* Side accent dots */}
      <circle cx="10" cy="20.5" r="1.2" fill="#00E5FF" />
      <circle cx="30" cy="20.5" r="1.2" fill="#00E5FF" />
      <circle cx="10" cy="20.5" r="0.5" fill="white" opacity="0.8" />
      <circle cx="30" cy="20.5" r="0.5" fill="white" opacity="0.8" />
    </svg>
  );
}
